export default "__VITE_ASSET__CFLs6VRa__"